import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';

const Checador = () => {
  const [scanResult, setScanResult] = useState('');

  useEffect(() => {
    const qrScanner = new Html5QrcodeScanner(
        'reader',
        {
          fps: 10,
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
          qrbox: { width: 250, height: 250 },
        }
      );

    qrScanner.render(
      (decodedText) => {
        setScanResult(decodedText); // Manejar resultado
        qrScanner.clear(); // Detener el escaneo tras encontrar un código
      },
      (errorMessage) => {
        console.error('Error escaneando QR:', errorMessage); // Manejar errores
      }
    );

    return () => qrScanner.clear(); // Limpieza al desmontar
  }, []);

  return (
    <div>
      <h1>Checador de QR</h1>
      <div id="reader" style={{ width: '98%', height: '85vh' }}></div>
      {scanResult && <p>Resultado: {scanResult}</p>}
    </div>
  );
};

export default Checador;
